@if (get(leadGenRow, 'lead_gen.lead_gen', false)) {
  <section class="lead-gen">
    @for (row of get(leadGenRow, 'lead_gen.lead_gen', []); track row) {
      <div>
        <div class="container d-flex flex-row justify-content-center align-items-center">
          <div class="lead-gen-text-container d-flex flex-column" [ngStyle]="{ 'background-color': row?.background_color }">
            <p class="lead-gen-title">{{ get(row, 'lead_gen_title', '') }}</p>
            <h2 class="lead-gen-copy">{{ get(row, 'lead_gen_copy', '') }}</h2>
            @if (get(row, 'marketo_form_selection.form_selection', '') !== 'no_form') {
              @if (get(row, 'marketo_form_selection.form_selection', '') == 'default_form') {
                <button-component
                  data-cy="marketo-form"
                        (click)="
                            solutionID && bootstrapMarketoService.openBootstrapMarketoDialog(solutionID, 'edit', {
                                title: dataTitle,
                                url: dataUrl
                            })
                        "
                        [buttonOptions]="{
                            text: get(row, 'lead_gen_link.title', ''),
                            type: 'tertiary',
                            disabled: !solutionID
                        }"
                ></button-component>
              }
              @if (get(row, 'marketo_form_selection.form_selection', '') == 'other_form') {
                <button-component
                  data-cy="marketo-form"
                        (click)="
                            get(row, 'marketo_form_selection.marketo_forms.id', '') && bootstrapMarketoService.openBootstrapMarketoDialog(get(row, 'marketo_form_selection.marketo_forms.id', ''), 'edit', {
                                title: dataTitle,
                                url: dataUrl
                            })
                        "
                        [buttonOptions]="{
                            text: get(row, 'lead_gen_link.title', ''),
                            type: 'tertiary',
                            disabled: !get(row, 'marketo_form_selection.marketo_forms.id', '')
                        }"
                ></button-component>
              }
            }
          </div>
        </div>
      </div>
    }
  </section>
}
@if (get(leadGenRow, 'lead_gen.split_line', '')) {
  <hr class="m-0 mb-3" />
}
